import React, { useEffect, useState } from "react";
import resume from "../assets/Kajibola.pdf";

function Header() {
  const [theme, setTheme] = useState(null);

  useEffect(() => {
    if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
      setTheme("dark");
    } else {
      setTheme("light");
    }
  }, []);

  useEffect(() => {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme(theme === "dark" ? "light" : "dark");
  };

  return (
    <>
      <div className=" w-full  fixed top-0 z-50 bg-white dark:text-white dark:bg-black   ">
        <div className=" container p-4 flex  max-w-screen-xl  mx-auto items-center justify-between md:flex-row md:px-6 lg:px-8 lg:justify-between">
          <div className="flex flex-row items-center justify-between lg:justify-start">
            <a
              href="/"
              className="text-lg font-bold tracking-tighter  transition duration-500 ease-in-out transform tracking-relaxed lg:pr-8 "
            >
              <p className=" border-l border-r border-t  border-black dark:border-white  border-spacing-x-1 pl-10 pr-10 capitalize">
                kehinde{" "}
              </p>
              <p className="border border-black dark:border-white border-spacing-x-1 pl-10 pr-10 capitalize">
                {" "}
                ajibola{" "}
              </p>
            </a>
          </div>
          <nav className="font-sen text-gray-800 dark:text-white uppercase text-lg  flex items-center ">
            <a
              href={resume}
              target="_blank"
              rel="noreferrer"
              className="py-2 px-6 flex hover:opacity-50"
            >
              Resume
            </a>

            <button
              className="light-mode hidden dark:block py-2 px-6  hover:opacity-50 "
              onClick={toggleTheme}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                />
              </svg>
            </button>

            <button
              className="dark-mode py-2 px-6  hover:opacity-40 dark:hidden"
              onClick={toggleTheme}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                />
              </svg>
            </button>
          </nav>
        </div>
      </div>
    </>
  );
}

export default Header;
